<template>
<div class="card schadeprocess">
	<div class="card-header">
		<h3>
			<span>			
				Hoe verloopt het schadeproces?
			</span>
		</h3>				
	</div>

	<div id="error-process"></div>
	
		<!-- LOADER -->
        	<loader-component v-if="!pageDataLoaded"></loader-component>
        <!-- /LOADER -->

			<!-- The v-if is necessary as the data needed won't be available till the ajax call is successful and complete, 
			so we don't want to render the component with only undefined data (which results in an error anyway) -->
	<div class="card-block" v-if="pageDataLoaded">
		<!-- menu -->

		<div class="process-menu messages">
			<div :class="[{'mobile-hide': polissen.length > 3}, {'hide': polissen.length === 1}, {'desktop-hide': polissen.length > 5}]">
				<ul class="nav nav-tabs flex-container">
					<li v-for="(polis, index) in polissen" 
						:key="polis.polisnummer"
						@click="currentTab = index"
						class="nav-item">
						<a v-bind:class="['nav-link', { active: currentTab === index }]">
							{{ polis.produktNaam }}<br />
							<span v-if="polis.kenteken">{{ polis.kenteken }}</span>
							<span v-if="polis.produktTypeNaam == 'woonhuis' || polis.produktTypeNaam == 'inboedel'">{{ polis.straat }}</span>
						</a>
					</li>
				</ul>
			</div>
		</div>

		<div class="selectbox-menu" :class="[{'desktop-hide': polissen.length < 6}, {'mobile-hide': polissen.length < 4}, {'hide': polissen.length === 1}]">
			<span>Selecteer een verzekering:</span>
			<select class="form-control" id="tab_selector" v-model="selected" @change="selectedTab">
				<option v-for="(polis, index) in polissen"
					:key="index"
					:selected="index === 0"
					:value="index">
						{{ polis.produktNaam }}
					<span v-if="polis.kenteken">- {{ polis.kenteken }}</span>
					<span v-if="polis.produktTypeNaam == 'woonhuis' || polis.produktTypeNaam == 'inboedel'">- {{ polis.straat }}</span>
				</option>
			</select>
			<br />
		</div>

		<!-- content -->
		<component
				:is = "currentTabComponent"
				:produktnaam = "currentTabName"
				:schademeldenurl = "currentSchadeUrl"
				:ctx = ctx
		></component>
	</div>  
</div> 
</template>

<script> 

import SchadeprocesAuto from './auto.vue'
import SchadeprocesCaravan from './caravan.vue'
import SchadeprocesBruiloft from './bruiloft.vue'
import SchadeprocesInboedel from './inboedel.vue'
import SchadeprocesReis from './reis.vue'
import SchadeprocesOngevallen from './ongevallen.vue'
import SchadeprocesAansprakelijkheid from './aansprakelijkheid.vue'
import SchadeprocesRechtsbijstand from './rechtsbijstand.vue'
import SchadeprocesWoonhuis from './woonhuis.vue'
import SchadeprocesDefault from './defaultproces.vue'

const processes = {
    auto: SchadeprocesAuto,
    camper: SchadeprocesAuto,
    motor: SchadeprocesAuto,
    brommer: SchadeprocesAuto,
	bruiloft: SchadeprocesBruiloft,
    caravan: SchadeprocesCaravan,
    reisverzekering_doorlopend: SchadeprocesReis,
    reisverzekering_tijdelijk: SchadeprocesReis,
    inboedel: SchadeprocesInboedel,
    ongevallen: SchadeprocesOngevallen,
    aansprakelijkheid: SchadeprocesAansprakelijkheid,
	rechtsbijstand: SchadeprocesRechtsbijstand,
    woonhuis: SchadeprocesWoonhuis
};

export default {
  name: 'schadeproces-component',
  props: {	  
	ctx: String
  },
  data: function () {
    return {    	
		currentTab: 0,
		polissen: [],
		produktnaam:'',
        schademeldenurl:'',
		pageDataLoaded: false,
		selected: '0' // this one is needed to make the selectbox work its magic
     }
  },
	methods: {
	  selectedTab () {
		var self = this;
		self.currentTab = this.selected;
		return self.currentTab
	}
  },
  mounted: function () {		
	var self = this;
	$.ajax({
		url: this.ctx + "/services/schadeproces/getall",
		type: 'GET',
		success: function(polissen) {
			self.polissen = polissen;	
			self.pageDataLoaded = true;		
		},
		error: function() {
			$('#error-process').html('<p>Er zijn geen verzekeringen gevonden. Probeert u het later nog eens.</p>');
            self.pageDataLoaded = true;
		}
	});	
  },
  computed: {
    currentTabComponent: function () {
        if(this.polissen.length > 0){
        	const process = this.polissen[this.currentTab].produktTypeNaam;
        	return processes[process] || SchadeprocesDefault;
        }
		else {
            return SchadeprocesDefault
		}
	},
	currentTabName: function () {
        if(this.polissen.length > 0) {
            return this.polissen[this.currentTab].produktNaam
        }
	},
	currentSchadeUrl: function () {
        if(this.polissen.length > 0) {
            return this.polissen[this.currentTab].schademeldenurl
        }
	}
  }

}

</script>




// WEBPACK FOOTER //
// schadeproces.vue?0c4eb18c